<template>
    <div class="tools-container">
        <div class="section-head">
            <span class="section-title">{{ dtitle }}</span>
            <span class="section-note">人气精选</span>
        </div>

        <div class="tool" v-for="item in dataList" :key="item.id">
            <div class="pic"><img :src="item.pic" alt="" /></div>
            <div class="info">
                <div class="title">{{ item.title }}</div>
                <span class="num">{{ item.num }}次下载</span>
                <span class="details">{{ item.details }}</span>
            </div>
            <a href="javascript:void(0)" class="download" @click="goDownload(item)">
                <van-icon name="down" />
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: ["dataList", "dtitle"],
    methods: {
        async goDownload(item) {
            if (!item || !item.url) return
            try {
                await this.$http.post('/track_click', {
                    target_type: 'app',
                    target_id: item.id
                })
            } catch (error) {
                // 统计失败不阻断下载跳转
            }
            window.open(item.url, '_blank')
        }
    }
};
</script>

<style lang="less" scoped>
.tools-container {
    border-radius: var(--a-radius);
}

.section-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: .6rem;
}

.section-title {
    color: #173d42;
    font-size: 1.05rem;
    font-weight: 800;
}

.section-note {
    color: #dd6f24;
    font-size: .8rem;
    font-weight: 700;
}

.tool {
    position: relative;
    min-height: 6.8rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: .7rem .5rem;
    margin-bottom: .6rem;
    border-radius: .95rem;
    border: 1px solid rgba(15, 89, 100, .13);
    background: linear-gradient(150deg, rgba(255, 255, 255, .96), rgba(255, 248, 236, .86));
    .pic {
        width: 5.8rem;
        height: 5.8rem;
        border-radius: .9rem;
        overflow: hidden;
        background: #f3ede2;
        border: 1px solid rgba(15, 89, 100, .14);
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }
    .info {
        flex: 1;
        min-height: 5.8rem;
        padding-left: .8rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title {
            max-width: 12rem;
            font-size: 1.08rem;
            font-weight: 800;
            color: #2b3434;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .num {
            font-size: .88rem;
            color: #0f5964;
            font-weight: 700;
        }
        .details {
            max-width: 16rem;
            font-size: .9rem;
            color: #6f6860;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .download {
        width: 2.2rem;
        height: 2.2rem;
        margin-left: .5rem;
        background: linear-gradient(120deg, #0f5964, #dd6f24);
        border-radius: 2rem;
        text-align: center;
        cursor: pointer;
        box-shadow: 0 8px 14px rgba(15, 89, 100, .22);
        animation: pulse-a 1.4s ease infinite;
        .van-icon {
            color: #fff;
            font-size: 1.2rem;
            font-weight: 700;
            line-height: 2.2rem;
        }
    }
}

@keyframes pulse-a {
    0% { transform: scale(1); }
    50% { transform: scale(1.1); }
    100% { transform: scale(1); }
}
</style>